/* eslint-disable */
import * as React from "react";
import TableComponent, { AgGridTableOptions } from "./Table";
import { DEFAULT_GRID_OPTIONS } from "./constants";
import { merge } from "lodash";
import { ColDef, GridOptions } from "ag-grid-community";

export type TableProps = {
  className?: string;
  options?: GridOptions;
  columns: ColDef[];
  rows: Record<string, unknown>[];
  tooltip?: 'default';
  loading?: boolean;
  getRowClass?: (params: any) => string;
  getCellClass?: (params: any) => string;
};

export const Table: React.FC<TableProps> = (props) => {
  const options = merge({}, DEFAULT_GRID_OPTIONS, props.options);
  return (
    <TableComponent
      className={props.className}
      loading={props.loading || false}
      gridOptions={options}
      columnDefs={props.columns}
      rowData={props.rows}
      getRowClass={props.getRowClass}
      getCellClass={props.getCellClass}
    />
  );
};
